export default __webpack_public_path__ + "static/media/athena-design.398ccf00.png";